module.exports = __webpack_public_path__ + "static/media/ripple-header-logo.e8386fa6.svg";